import React from 'react'
import { IconButton, Grid, useTheme, Toolbar } from '@material-ui/core'
import {
  Dashboard as DashboardIcon,
  Movie as MovieIcon,
  Games as GamesIcon,
  Lock as LockIcon,
} from '@material-ui/icons'
import { useHistory } from 'react-router-dom'
import { useStore } from '../../context/Context'

const MobileAdminNavigation = () => {
  const { selectedDrawer, setSelectedDrawer } = useStore()
  const history = useHistory()
  const theme = useTheme()

  return (
    <div style={{ width: '100%', paddingBottom: '1em' }}>
      <Toolbar />
      <Grid container justifyContent="space-evenly" style={{ marginTop: '0.5em' }}>
        <IconButton
          style={selectedDrawer === 0 ? { color: theme.palette.primary.main } : undefined}
          onClick={() => {
            setSelectedDrawer(0)
            history.push('/dashboard')
          }}
        >
          <DashboardIcon />
        </IconButton>
        <IconButton
          style={selectedDrawer === 1 ? { color: theme.palette.primary.main } : undefined}
          onClick={() => {
            setSelectedDrawer(1)
            history.push('/moviesDb')
          }}
        >
          <MovieIcon />
        </IconButton>
        <IconButton
          style={selectedDrawer === 2 ? { color: theme.palette.primary.main } : undefined}
          onClick={() => {
            setSelectedDrawer(2)
            history.push('/gamesDb')
          }}
        >
          <GamesIcon />
        </IconButton>
        <IconButton
          style={selectedDrawer === 3 ? { color: theme.palette.primary.main } : undefined}
          onClick={() => {
            setSelectedDrawer(3)
            history.push('/changePassword')
          }}
        >
          <LockIcon />
        </IconButton>
      </Grid>
    </div>
  )
}

export default MobileAdminNavigation
